const OngoingProgramDetails = [
  {
    id: 1,
    title: "UNIFIED- A Course from Babaji to Connect to Higher-Self",
    date: "EVERY MORNING",
    time: "5.30 AM EST | 4.30 AM CST",
    img: require("./images/unified.jpeg"),
    zoom_link:
      "https://us02web.zoom.us/j/85267955865?pwd=nU7isXDLzemP91SDoNKxRvAQfqHeq4.1",
    zoom_meeting_id: "852 6795 5865",
    zoom_passcode: "1111",
    youtube_link:
      "https://www.youtube.com/live/UZesdhL-kGs?si=5ehelHwNZECSqb6b",
  },
  {
    id: 2,
    title: "PIONEERING HEROS OF PYRAMID MEDITATION IN THE USA",
    date: "EVERY MORNING",
    time: "5.30 AM EST | 4.30 AM CST",
    img: require("./images/USAHeros.jpeg"),
    zoom_link:
      "https://us06web.zoom.us/j/81131889319?pwd=hAsPPs4OSWFSxUvTrVGytJ6LhbqCaR.1",
    zoom_meeting_id: "811 3188 9319",
    zoom_passcode: "1111",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
  {
    id: 7,
    title: "Pitamaha Merkaba Pyramid",
    date: "EVERY MORNING",
    time: "5.30 AM EST | 4.30 AM CST",
    img: require("./images/Merkaba.jpeg"),
    zoom_link:
      "https://us02web.zoom.us/j/88156147133?pwd=eaglBDQLvxVwD8MbE5WsyMDVmZXQVU.1",
    zoom_meeting_id: "",
    zoom_passcode: "",
    youtube_link: "https://www.youtube.com/@PMCUSAMULTILINGUAL",
  },
  {
    id: 7,
    title: "Full Moon Eclipse Meditation",
    date: "September 17th",
    time: "10:00 PM EST | 9:00 PM CST | 7:00 PM PST",
    img: require("./images/Fullmoon.jpeg"),
    zoom_link:
      "https://us06web.zoom.us/j/88346155477?pwd=KKbzeI28bDmKZmOvRfgA3AzcXVzw7g.1",
    zoom_meeting_id: "",
    zoom_passcode: "",
    youtube_link: "https://www.youtube.com/@PMCUSA",
    location: "New Jersey",
  },
  {
    id: 7,
    title: "Full Moon Eclipse Meditation",
    date: "September 17th",
    time: "10:00 PM EST | 9:00 PM CST | 7:00 PM PST",
    img: require("./images/Fullmoon.jpeg"),
    zoom_link:
      "https://us06web.zoom.us/j/88346155477?pwd=KKbzeI28bDmKZmOvRfgA3AzcXVzw7g.1",
    zoom_meeting_id: "",
    zoom_passcode: "",
    youtube_link: "https://www.youtube.com/@PMCUSA",
    location: "New Jersey",
  },
  // {
  //   id: 8,
  //   title: "MMS 2 Success Celebrations ",
  //   date: "EVERYDAY EVENING",
  //   time: "9:30 PM EST | 8:30 PM CST | 6:30 PM PST",
  //   img: require("./images/MMS2_17.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/86840755025?pwd=89AAlUX5KoJjbIfSL7n66MGzby2bfI.1",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 9,
  //   title: "Journey Towards True Path - 33",
  //   date: "Sept 25 - Oct 20",
  //   time: "7 PM EST | 6 PM CST | 4 PM PST",
  //   img: require("./images/JTTP.jpeg"),
  //   zoom_link:
  //     "https://docs.google.com/forms/d/e/1FAIpQLSfRx77ODlxfQlEOVIxAJPcZbZvW_4zCtQcbg4mhM5QOzUOV8g/viewform?usp=sf_link",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },

  // {
  //   id: 6,
  //   title: "Patriji's Amruthotsavam",
  //   date: "June 24th - July 24th",
  //   time: "9:30 PM EST | 8:30 PM CST | 6:30 PM PST",
  //   img: require("./images/Patrijis_Amruthatsavam.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/88573497576?pwd=bRZWbkowtdvpIbm9pq4gUblaG1ASVO.1",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 7,
  //   title: "Meditation to Energise MMS-2",
  //   date: "August 1st - August 21st",
  //   time: "9:30 PM EST | 8:30 PM CST | 6:30 PM PST",
  //   img: require("./images/MMS2.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/89318100628?pwd=Wly1qgmaOaMZYuR6cknL9K0UoROhGv.1",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 5,
  //   title: "PMC USA to conduct 50 States 50 Masters 50 days",
  //   date: "EVERY DAY FROM MAY 5",
  //   time: "9:30 pm - 10:30 pm EST",
  //   img: require("./images/50States.jpg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/81593457497?pwd=enFjY2FSY1M0M3ozRThDNVdIMERsZz09",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 4,
  //   title: "SANKALPA DHYAN FOR RALEIGH PYRAMID PROJECT",
  //   date: "FEB 8th to MARCH 18th",
  //   time: "9pm to 10pm EST",
  //   img: require("./images/Raleigh_41days.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/85876011955?pwd=eTNCMFlGUHIzUnhUTG4zZTZHZVRWUT09",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 3,
  //   title: "DAILY MORNING MEDITATIONS.",
  //   date: "EVERY DAY MORNING",
  //   time: "5:30 AM EST- 6:30 AM EST",
  //   img: require("./images/Enlightenment.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/83299568390?pwd=RWV1eGNoS2J2TENxaXdQS1p0Y3NnQT09",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 2,
  //   title: "MEDITATION INPROGRESS.",
  //   date: "EVERY DAY FROM FEB 1st to FEB 21st ",
  //   time: "9 pm - 10 pm EST",
  //   img: require("./images/Meditation_InProgress.jpeg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/84222169270?pwd=gPXqda2lbyY4no3aINvj4nOkCpOkud.1",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },

  // {
  //   id: 2,
  //   title: "PSSM MEDITATION SUMMIT - Tennessee",
  //   date: "JANUARY 27th 2024 ",
  //   time: "8:00pm to 8:45pm CST",
  //   img: require("./images/Monthly_MMS_Jan.jpg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/81661521261?pwd in=KzlSc0ZUSDZDemR6dEl2WVo5VHdlQT09",
  //   zoom_meeting_id: "816 6152 1261",
  //   zoom_passcode: "111111",
  //   youtube_link: "https://youtube.com/live/f1P5AepH3no?feature=share",
  // },
  // {
  //   id: 3,
  //   title: "SWADHYAYA CHALLENGE: Book Readings",
  //   date: "Every Mondays 4PM ",
  //   time: "8:00pm to 8:45pm CST",
  //   img: require("./images/Monthly_MMS_Jan.jpg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/81661521261?pwd in=KzlSc0ZUSDZDemR6dEl2WVo5VHdlQT09",
  //   zoom_meeting_id: "816 6152 1261",
  //   zoom_passcode: "111111",
  //   youtube_link: "https://youtube.com/live/f1P5AepH3no?feature=share",
  // },
];

const UpComingOnlinePrograms = [
  // {
  //   id: 2,
  //   title: " SWADHYA CHALLENGE",
  //   date: "FEB - 13",
  //   time: "8:30 pm - 9.30 pm EST",
  //   img: require("./images/SwadhyaChallenge.jpeg"),
  //   zoom_link: "",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
];

const RecentProgramDetails = [
  {
    id: 1,
    title: "Heal Your Life with Mirror Work workshop",
    date: "EVERY MORNING",
    time: "4.30 AM CST | 5.30 AM EST",
    img: require("./images/MirrorWS.jpeg"),
    zoom_link:
      "https://us02web.zoom.us/j/86865160629?pwd=uaZsSRppS410nTdiXNk91oOeqKZ2Dv.1",
    zoom_meeting_id: "868 6516 0629",
    zoom_passcode: "9999",
    youtube_link: "https://www.youtube.com/live/NhGB2aoVeu8",
  },
  {
    id: 8,
    title: "PSSM MEDITATION SUMMIT",
    date: "June 22nd",
    time: "9AM to 4PM EST",
    img: require("./images/Virgina_DMC.jpeg"),
    venu_location:
      "Eagle Ridge Middle School, 42901 Waxpool Rd, Ashburn, VA, 20148",
    registration_link: "http://tiny.cc/9wqxxz",
    youtube_link: "https://www.youtube.com/live/1vkvQ65bnic",
  },
  {
    id: 7,
    title: "PSSM MEDITATION SUMMIT",
    date: "May 25th",
    time: "9AM to 4PM EST",
    img: require("./images/PSSM_MINI_TEXAS_2.jpeg"),
    venu_location:
      "Shridi Sai Community Hall, 2509 W New Hope Dr, Cedar Park, TX 78613",
    registration_link: "https://guestlist.co/u/pssmaustin",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
  {
    id: 6,
    title: "PSSM MEDITATION SUMMIT",
    date: "April 27th",
    time: "10 AM to 4PM EST",
    img: require("./images/MINI_DMC_OHIO_2.jpeg"),
    venu_location: "5071 , Wallings Rd, North Royalton, OH 44133",
    registration_link: "https://tinyurl.com/PSSM-Meditation-cle-OH",
    youtube_link: "https://www.youtube.com/watch?v=k8omuN1p-Pc",
  },
  {
    id: 5,
    title: "PSSM MEDITATION SUMMIT",
    date: "March 23rd",
    time: "9AM to 4PM EST",
    img: require("./images/PSSM_MINI_GA2.jpeg"),
    venu_location: "Banjara Banquets, 1656 Buford Hwy, Cumming, GA 30041",
    registration_link: "http://tinyurl.com/pssm-atl",
    youtube_link: "https://www.youtube.com/watch?v=99BMHJOCbCY",
  },
  {
    id: 4,
    title: "PSSM MEDITATION SUMMIT",
    date: " February 24th",
    time: "9AM to 4PM EST",
    img: require("./images/NJ_MMST.jpeg"),
    venu_location: "Ved Mandir, 1 Ved Mandir Dr, Milltown, NJ 08850",
    registration_link:
      "https://docs.google.com/forms/d/e/1FAIpQLScjRc7GlGICYRzGbxRBwZo3QXKdcpXOvpWK6RiELMh6UxFdgA/viewform",
    youtube_link: "https://www.youtube.com/watch?v=A6AruSLMYT4",
  },
  {
    id: 3,
    title: "PSSM MEDITATION SUMMIT",
    date: "27th January 2024 - Saturday",
    time: "10 AM to 4 PM CST",
    img: require("./images/Monthly_MMS_Jan.jpg"),
    // venu_location:
    //   "Nolensville First United Methodist Church, 7316 Nolensville Rd, Nolensville TN 37135",
    // registration_link:
    //   "https://docs.google.com/forms/d/e/1FAIpQLSdrSA5uFz5qQ6bBwT-_eAyIBrL2O7SZUTX6-xZAhM4l7RXzGg/viewform",
    youtube_link: "https://www.youtube.com/watch?v=XyKvcqvVlCM",
  },
  {
    id: 2,
    title: "Harmony Within - Workshop in Atlanta",
    date: "26th January 2024 - Friday",
    time: "6.30 PM to 8 PM EST",
    img: require("./images/SPT_Chandra_Sir.jpeg"),
    // venu_location:
    //   "Nine East Building (Behind Kroger) 1740 Grassland Parkway, Block 400 Alpharetta, Georgia 30004",
    // registration_link: "https://forms.gle/D7NhKtRrjX8eKxfG6",
    youtube_link: "https://www.youtube.com/watch?v=kUTAzZCdFH0",
  },
  {
    id: 1,
    title: "CHANGE WHAT YOU EAT CHANGE THE WORLD",
    date: "NOV 19th 2023 ",
    time: "8.30 PM to 10 PM EST",
    img: require("./images/gaurav.jpeg"),
    // zoom_link:
    //   "https://us02web.zoom.us/j/83299568390?pwd=SUJOZWsyUGE3ei9naEUvMTJUdHEwdz09",
    // zoom_meeting_id: "832 9956 8390",
    // zoom_passcode: "801942",
    youtube_link: "https://www.youtube.com/watch?v=8QSMI2Oy9Q4&t=3s",
  },
];

const InPersonProgramDetails = [
  // {
  //   id: 1,
  //   title: "Music Meditation for Inner Peace",
  //   date: "September 21",
  //   time: "3 PM - 6 PM CST",
  //   img: require("./images/PMMA.jpeg"),
  //   venu_location:
  //     " Austin Hindu Temple & Community Center 9801 Decker Lane Road, Austin, Texas 78724",
  //   registration_link: "https://guestlist.co/events/784632",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  {
    id: 2,
    title: "Music Meditation for Inner Peace",
    date: "2nd November",
    time: "3 PM - 6 PM CST",
    img: require("./images/PMMA_TN.jpeg"),
    venu_location:
      "Inglehame Farms Club House 9190 Sydney Ln, Brentwood, TN 37027",
    registration_link: "https://guestlist.co/events/788214",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
  // {
  //   id: 2,
  //   title: "PSSM MEDITATION SUMMIT 2",
  //   date: "August 30th to September 2nd",
  //   time: "9AM to 4PM EST",
  //   img: require("./images/PSSM_MEGA_SUMMIT2.jpeg"),
  //   venu_location: "Raleigh, NC",
  //   registration_link: "https://bit.ly/MMS-PSSM",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // PSSM_MEGA_SUMMIT2.jpeg
];

const NJInpersonProgramDetails = [
  {
    id: 2,
    title: "PSSM MEDITATION SUMMIT 2",
    date: "August 30th to September 2nd",
    time: "9AM to 4PM EST",
    img: require("./images/PSSM_MEGA_SUMMIT2.jpeg"),
    venu_location: "Raleigh, NC",
    registration_link: "https://bit.ly/MMS-PSSM",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
];

const NJOngoingProgramDetails = [
  // {
  //   id: 1,
  //   title: " BEGINNERS 41 DAYS GROUP MEDITATION.",
  //   date: "EVERY MORNING ",
  //   time: "5:00 AM - 6:15 AM PST",
  //   img: require("./images/MRNG_41_Days.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/87976706115?pwd=RFZTSTEzbzM5L2N2Q2ZiMjMyMmNkQT09",
  //   zoom_meeting_id: "879 7670 6115",
  //   zoom_passcode: "555 555",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  {
    id: 6,
    title: "Patriji's Amruthotsavam",
    date: "June 24th - July 24th",
    time: "9:30 PM EST | 8:30 PM CST | 6:30 PM PST",
    img: require("./images/Patrijis_Amruthatsavam.jpeg"),
    zoom_link:
      "https://us02web.zoom.us/j/88573497576?pwd=bRZWbkowtdvpIbm9pq4gUblaG1ASVO.1",
    zoom_meeting_id: "",
    zoom_passcode: "",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
  // {
  //   id: 5,
  //   title: "PMC USA to conduct 50 States 50 Masters 50 days",
  //   date: "EVERY DAY FROM MAY 5",
  //   time: "9:30 pm - 10:30 pm EST",
  //   img: require("./images/50States.jpg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/81593457497?pwd=enFjY2FSY1M0M3ozRThDNVdIMERsZz09",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  // {
  //   id: 4,
  //   title: "SANKALPA DHYAN FOR RALEIGH PYRAMID PROJECT",
  //   date: "FEB 8th to MARCH 18th",
  //   time: "9pm to 10pm EST",
  //   img: require("./images/Raleigh_41days.jpeg"),
  //   zoom_link:
  //     "https://us02web.zoom.us/j/85876011955?pwd=eTNCMFlGUHIzUnhUTG4zZTZHZVRWUT09",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },
  {
    id: 3,
    title: "DAILY MORNING MEDITATIONS.",
    date: "EVERY DAY MORNING",
    time: "5:30 AM EST- 6:30 AM EST",
    img: require("./images/Enlightenment.jpeg"),
    zoom_link:
      "https://us02web.zoom.us/j/83299568390?pwd=RWV1eGNoS2J2TENxaXdQS1p0Y3NnQT09",
    zoom_meeting_id: "",
    zoom_passcode: "",
    youtube_link: "https://www.youtube.com/@PMCUSA",
  },
  // {
  //   id: 2,
  //   title: "MEDITATION INPROGRESS.",
  //   date: "EVERY DAY FROM FEB 1st to FEB 21st ",
  //   time: "9 pm - 10 pm EST",
  //   img: require("./images/Meditation_InProgress.jpeg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/84222169270?pwd=gPXqda2lbyY4no3aINvj4nOkCpOkud.1",
  //   zoom_meeting_id: "",
  //   zoom_passcode: "",
  //   youtube_link: "https://www.youtube.com/@PMCUSA",
  // },

  // {
  //   id: 2,
  //   title: "PSSM MEDITATION SUMMIT - Tennessee",
  //   date: "JANUARY 27th 2024 ",
  //   time: "8:00pm to 8:45pm CST",
  //   img: require("./images/Monthly_MMS_Jan.jpg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/81661521261?pwd in=KzlSc0ZUSDZDemR6dEl2WVo5VHdlQT09",
  //   zoom_meeting_id: "816 6152 1261",
  //   zoom_passcode: "111111",
  //   youtube_link: "https://youtube.com/live/f1P5AepH3no?feature=share",
  // },
  // {
  //   id: 3,
  //   title: "SWADHYAYA CHALLENGE: Book Readings",
  //   date: "Every Mondays 4PM ",
  //   time: "8:00pm to 8:45pm CST",
  //   img: require("./images/Monthly_MMS_Jan.jpg"),
  //   zoom_link:
  //     "https://us06web.zoom.us/j/81661521261?pwd in=KzlSc0ZUSDZDemR6dEl2WVo5VHdlQT09",
  //   zoom_meeting_id: "816 6152 1261",
  //   zoom_passcode: "111111",
  //   youtube_link: "https://youtube.com/live/f1P5AepH3no?feature=share",
  // },
];

export {
  RecentProgramDetails,
  OngoingProgramDetails,
  InPersonProgramDetails,
  UpComingOnlinePrograms,
  NJInpersonProgramDetails,
  NJOngoingProgramDetails,
};
